module.exports = __webpack_public_path__ + "img/start.d5d4a21b.png";